export default "__VITE_ASSET__782f299b__"